(ns ui.components.skeleton.view
  (:require [ui.util :as uu]))

(defn view
  [props]
  (let [classname (:class props)
        props (dissoc props :class)]
    [:div
     (merge
      {:class (uu/cm "animate-pulse bg-base-regular rounded-md" classname)}
      props)]))
